import { BalanceData, BossMechanic } from "../data/balance";

/**
 * Where free gems come from (D20, ADR 0013; chests.json `gems`, orders.json `weeklyGems` and check-in `gems`): star
 * chests, the weekly order chest, the check-in's gem days (1, 7, 21, 28) and boss first clears here; achievements and events pay through
 * `Wallet.grantGems` with their own data. Never battle chests: their contents are part of the replay hash.
 */

/** Gems a chapter's `milestone`-th star chest (0-based) pays. */
export function starChestGems(balance: BalanceData, milestone: number): number {
  return balance.commerce.gems.starChests[milestone] ?? 0;
}

/**
 * The first level each named boss guards (a boss enemy with a mechanic, in campaign order: 7, 11, 21, 31, 41, 51
 * today), with the gems its first clear pays.
 */
export function bossFirstClears(balance: BalanceData): { level: number; bossId: string; gems: number }[] {
  const seen = new Set<number>();
  const out: { level: number; bossId: string; gems: number }[] = [];
  for (const l of balance.levels) {
    const boss = balance.enemies[l.bossEnemyIndex];
    if (boss.bossMechanic === BossMechanic.None || seen.has(boss.index)) continue;
    seen.add(boss.index);
    out.push({ level: l.id, bossId: boss.id, gems: balance.commerce.gems.bossFirstClear.get(boss.id) ?? 0 });
  }
  return out;
}

/** Gems the first clear of `level` pays (0 unless it is a boss's first level). */
export function bossFirstClearGems(balance: BalanceData, level: number): number {
  return bossFirstClears(balance).find((b) => b.level === level)?.gems ?? 0;
}
